@let fieldData = field();
@let formControl = control();

@if (formControl) {
  <div class="mb-6 relative">
    <tui-textfield
      class="workflow-field"
      tuiTextfieldSize="l"
      [tuiTextfieldCleaner]="true"
    >
      <label tuiLabel>
        <span
          [class.font-extrabold!]="fieldData.isHighlighted"
          class="x-text-wf-title x-font-body-3-important"
        >
          {{ fieldData.title }}
        </span>
        @if (fieldData.validation?.isRequired) {
          <span class="font-extrabold x-font-body-3-important">*</span>
        }
      </label>
      <input tuiInput [formControl]="formControl" />
      @if (fieldData.helpText) {
        <tui-icon [tuiTooltip]="fieldData.helpText" />
      }
    </tui-textfield>

    @if (formControl.invalid && (formControl.dirty || formControl.touched)) {
      <div class="x-text-wf-error x-font-body-5 mt-1 absolute">
        @if (formControl.hasError('required')) {
          <span>Обязательное поле</span>
        }
        @if (formControl.hasError('minlength')) {
          <span
            >Минимальная длина:
            {{ formControl.getError('minlength').requiredLength }}</span
          >
        }
        @if (formControl.hasError('maxlength')) {
          <span
            >Максимальная длина:
            {{ formControl.getError('maxlength').requiredLength }}</span
          >
        }
        @if (formControl.hasError('pattern')) {
          <span>Неверный формат</span>
        }
        @if (formControl.hasError('email')) {
          <span>Неверный формат email</span>
        }
        @if (formControl.hasError('customError')) {
          <span>Ошибка валидации</span>
        }
      </div>
    }
  </div>
}
